import axios from 'axios';
import { requestInterceptor } from './interceptors/request';
import { responseInterceptor, errorInterceptor } from './interceptors/response';

const axiosInstance = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Accept: 'application/json'
  }
});

// Request Interceptors
axiosInstance.interceptors.request.use((request) => requestInterceptor(request));

// Response Interceptors
axiosInstance.interceptors.response.use(
  (response) => responseInterceptor(
    JSON.parse(JSON.stringify(response))
  ),
  (error) => errorInterceptor(error)
);

export default axiosInstance;
